import { applyMiddleware, combineReducers, createStore, compose } from 'redux'
import user, { restoreState as restoreUserState } from 'user'
import application, { restoreState as restoreApplicationState } from 'application'
import { pick } from 'utils'

const redraw = store => next => action => {
    next(action)
    action.redraw && m.redraw()
}

let initialState = null
try {
  const stateStr = localStorage.getItem('state') || sessionStorage.getItem('state')
  if(stateStr) initialState = JSON.parse(stateStr)
} catch(e) {}

Array({ key: 'user', fn: restoreUserState }, { key: 'application', fn: restoreApplicationState }).forEach( ({ key, fn }) => {
  try {
    if(initialState[key]) initialState = i.set(initialState, key, restoreState(initialState[key], initialState))
  } catch(e) {}
})

function config(state = { storeData: false }, { type, data }) {
  if(type === 'config/SET_STORE_DATA') {
    return i.set(store, 'storeData', data)
  }
  return state
}

const store = createStore(
  combineReducers({ user, application, config })
  , initialState || {}
  , compose(applyMiddleware(redraw), window.devToolsExtension ? window.devToolsExtension() : f => f))

function getDataToPersist(state) {
  return pick(state, 'user', 'application', 'config')
}

let savedCache = null
store.subscribe( () => {
  const state = store.getState()
  const data = getDataToPersist(state)
  if(data === savedCache) return
  savedCache = data
  const str = JSON.stringify(savedCache)
  if(state.config.storeData) {
    localStorage.setItem('state', str)
  } else {
    localStorage.removeItem('state')
    if(state.user.activelyLoggedOut) {
      sessionStorage.removeItem('state')
    } else {
      sessionStorage.setItem('state', str)
    }
  }
})

export default store

export const dispatch = store.dispatch
